import { z } from 'zod';

const mwCountrySchema = z.object({
  id: z.string(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
  code: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  callPrefix: z.string().optional(),
});

const mwAccountGroupSchema = z.object({
  id: z.string(),
  accountGroup: z.string(),
  mwEntity: z.string(),
});

const taxOfficeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});

export const getTraderDetailsSchema = z.object({
  id: z.string(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
  createdDate: z.string(),
  lastUpdate: z.string().optional(),
  createUserId: z.string(),
  updateUserId: z.string().optional(),
  code: z.string(),
  name: z.string(),
  title: z.string().optional(),
  job: z.string().optional(),
  taxNumber: z.string().optional(),
  doy: z.string().optional(),
  county: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  zipCode: z.string().optional(),
  email: z.string().optional(),
  telephone1: z.string().optional(),
  telephone2: z.string().optional(),
  remarks: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  socialNumberId: z.string().optional(),
  passportId: z.string().optional(),
  adt: z.string().optional(),
  adT_date: z.string().optional(),
  passportExpiredDate: z.string().optional(),
  mwCountryId: z.string().optional(),
  mwCountry: mwCountrySchema.optional(),
  mwAccountGroupId: z.string(),
  mwAccountGroup: mwAccountGroupSchema,
  taxOfficeId: z.string().optional(),
  taxOffice: taxOfficeSchema.optional(),
});

export type GetTraderDetails = z.infer<typeof getTraderDetailsSchema>;
